import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import $ from 'jquery';

import { selectUrlData } from '../../redux/train/train.selector';

import iconBack from '../../assets/back-arrow.png';
import iconClose from '../../assets/close.png';

class FaqDetailsTrainInfo extends React.Component {
    constructor(props) {
        super(props);
        window.jQuery = $;
        window.$ = $;
        global.jQuery = $;
    }
    myFunction(e) {
        $('.single-faq').removeClass('active');
        $(e).parent('.single-faq').addClass('active');
    }
    render() {
        const { urlData } = this.props;
        return (
            <div>
                <div className="faq-header">
                    <a href={'/ttbhelp?' + urlData}><img src={iconBack} alt="" title="" /></a>
                    <h2>Frequently Asked Questions(FAQ):</h2>
                    <Link to={'/ttbhelp/faq'}><img src={iconClose} alt="" title="" /></Link>
                </div>
                <div className="faq-content">
                    <h4>Train Information and Travel Guidance</h4>

                    <h2>What do you need help with?</h2>

                    <div className="faq-accordian">
                        <div className="single-faq active">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I find out about train schedules and routes?</h3>
                            <p>To find train schedules and routes, you can use the following features in the RailYatri app or website:</p>

                            <p>Search for Trains: Enter your source and destination stations to find trains for your journey.<br />
                                Seat Availability: Check seat availability on specific trains for your preferred travel date.<br />
                                Trains Between Stations: Find trains running between two stations.<br />
                                Time Table: View detailed train schedules and routes.<br />
                                Live Arrival/Departure: Get real-time updates on train arrivals and departures.<br />
                                Train Search: Use this option to search for specific trains and their schedules."</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What are the different classes of travel available in Indian Railways?</h3>
                            <p>Indian Railways offers various classes of travel, each catering to different levels of comfort and price points. Here are the main travel classes:<br />
                                First Class AC (1A): Luxury cabins with AC.<br />
                                AC 2-Tier (2A): AC with two-tier sleeping berths.<br />
                                AC 3-Tier (3A): AC with three-tier sleeping berths.<br />
                                Sleeper Class (SL): Non-AC with three-tier berths.<br />
                                Second Sitting (2S): Non-AC seating for short distances.<br />
                                AC Chair Car (CC): Reclining seats in AC.<br />
                                General Class: Unreserved seating.</p>

                            <p>These classes allow passengers to choose a travel option based on their budget and comfort preferences.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What is the difference between Sleeper, EC, CC, AC 3 Tier, AC 2 Tier, and First Class?</h3>
                            <p>Key Differences:<br />
                                First Class AC (1A):<br />
                                The most luxurious and expensive class with spacious cabins, privacy, and bedding.<br />
                                Cabins are air-conditioned and can accommodate 2 or 4 passengers.</p>

                            <p>AC 2-Tier (2A):<br />
                                Fully air-conditioned with sleeping berths arranged in tiers of two.<br />
                                Provides bedding, curtains for privacy, and slightly more space compared to 3A.</p>

                            <p>AC 3-Tier (3A):<br />
                                Air-conditioned with three tiers of sleeping berths on each side.<br />
                                Offers bedding but less privacy and space compared to 2A.</p>

                            <p>Sleeper Class (SL):<br />
                                Non-AC class with three-tier berths.<br />
                                Most affordable long-distance travel option, but without air-conditioning or bedding.</p>

                            <p>Second Sitting (2S):<br />
                                Non-AC, with seating arranged in rows.<br />
                                Typically used for short-distance journeys.</p>

                            <p>Executive Class (EC):<br />
                                Available in premium trains like Shatabdi Express.<br />
                                Similar to business class in flights, with reclining seats and air-conditioning.</p>

                            <p>AC Chair Car (CC):<br />
                                Air-conditioned class with reclining seats arranged in rows.<br />
                                Ideal for short journeys and found in trains like Shatabdi Express.</p>

                            <p>General Class (Unreserved):<br />
                                The most affordable class, offering basic seating without reservation.<br />
                                No air-conditioning and can be crowded."</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I know if a train is running on time?</h3>
                            <p>Step 1: Open the RailYatri app.<br />
                                Step 2: Use the "Live Train Status" feature.<br />
                                Step 3: Enter your train number to get real-time updates on its arrival, departure, and delays.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What are the rules for carrying luggage on the train?</h3>
                            <p>Here are the key rules for carrying luggage on Indian Railways trains:</p>

                            <p>1. Free Luggage Allowance:<br />
                                Each class has a specific limit for the amount of luggage passengers can carry for free:</p>

                            <p>First Class AC (1A): 70 kg<br />
                                AC 2-Tier (2A): 50 kg<br />
                                AC 3-Tier (3A), AC Chair Car (CC): 40 kg<br />
                                Sleeper Class (SL): 40 kg<br />
                                Second Class (General): 35 kg<br />
                                2. Maximum Luggage Limit:<br />
                                Passengers can carry luggage beyond the free allowance up to the following limits, but additional charges apply:</p>

                            <p>First Class AC (1A): 150 kg<br />
                                AC 2-Tier (2A): 100 kg<br />
                                AC 3-Tier (3A), AC Chair Car (CC): 80 kg<br />
                                Sleeper Class (SL): 80 kg<br />
                                Second Class (General): 70 kg<br />
                                3. Excess Luggage:<br />
                                If your luggage exceeds the free allowance but is still within the maximum limit, you need to book it in the luggage van and pay extra charges. You can do this at the railway station's parcel office.</p>

                            <p>4. Luggage in Compartments:<br />
                                Passengers can carry small pieces of luggage like handbags and small suitcases inside the coach as long as it fits in the available storage (usually under the seats).<br />
                                Larger items must be booked separately and placed in the luggage van.<br />
                                Avoid blocking aisles or emergency exits with luggage.<br />
                                5. Prohibited Items:<br />
                                Hazardous or inflammable substances like explosives, petrol, and chemicals are strictly prohibited.<br />
                                Carrying items that cause inconvenience to fellow passengers is also not allowed.<br />
                                6. Checking Luggage:<br />
                                Luggage is generally not checked, but random inspections can be carried out. If your luggage exceeds the allowed weight and is not booked properly, you may be fined.</p>

                            <p>7. Bicycles and Oversized Items:<br />
                                For large items such as bicycles, you'll need to book them in the luggage van and pay additional charges at the parcel office.</p>

                            <p>8. Carrying Pets:<br />
                                Pets, such as dogs, can be carried in First Class AC (1A) compartments or in the luggage van. There are specific charges, and prior booking is required for pets.<br />

                                By adhering to these rules, you can avoid any issues while carrying luggage during your train journey.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I find my train’s platform at the station?</h3>
                            <p>Step 1: Open the RailYatri app.<br />
                                Step 2: Use the "Live Train Status" feature to check the platform number by entering your train number.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What should I do if I lose my ticket during the journey?</h3>
                            <p>You can retrieve your e-ticket from the RailYatri app or IRCTC account. Inform the TTE (Traveling Ticket Examiner) to avoid penalties.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What are the rules for traveling with pets on Indian Railways?</h3>
                            <p>Here are the rules for traveling with pets on Indian Railways:</p>

                            <p>1. First Class AC (1A):<br />
                                Pets are allowed in First Class AC cabins if you book an entire compartment for yourself.<br />
                                You need to inform the railway authorities in advance when booking, and there may be additional charges for carrying pets.<br />
                                If you don't book the whole compartment, other passengers must consent to allowing the pet in the cabin.<br />
                                2. Luggage Van:<br />
                                If you cannot book a First Class cabin, pets must travel in the luggage van.<br />
                                You'll need to book a special box for your pet at the railway station's parcel office.<br />
                                The box must be large enough for the pet to sit or lie comfortably, and you must provide food and water for the journey.<br />
                                3. Charges:<br />
                                Pets traveling in the luggage van or First Class compartments will be charged based on weight and distance.<br />
                                Rates are available at the railway station's parcel or luggage booking office.<br />
                                4. Prohibited Areas:<br />
                                Pets are not allowed in AC 2-Tier, AC 3-Tier, Sleeper, or general compartments, even if you book an entire section.<br />
                                You cannot take pets into pantry cars, dining cars, or train stations' public areas without appropriate containment (leash or carrier).<br />
                                5. Assistance Animals:<br />
                                Guide dogs or assistance animals for passengers with disabilities are allowed in all classes, but prior arrangements need to be made.<br />
                                6. Responsibility:<br />
                                Passengers are responsible for feeding, managing, and cleaning up after their pets during the journey.<br />
                                The railway is not liable for any injury, illness, or death of the pet during the journey.<br />
                                7. Booking Process:<br />
                                You should contact the parcel office or booking office at the station a few hours before departure to complete the necessary paperwork and make arrangements for your pet.<br />
                                By following these rules, you can ensure a safe and comfortable journey for your pet on Indian Railways.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I upgrade my seat or class after booking?</h3>
                            <p>To upgrade your seat or class after booking a train ticket with Indian Railways, you have the following options:<br />
                                Automatic Upgradation Scheme: Passengers may be automatically upgraded to a higher class at no extra cost if seats are available. This is done during chart preparation if opted for at booking.</p>

                            <p> Approach the Reservation Office: Visit the railway reservation office at least 24 hours before departure, pay the fare difference, and request an upgrade (subject to availability).</p>

                            <p> Contact TTE During the Journey: Request an upgrade from the TTE if vacant seats are available after departure. Pay the fare difference for the upgrade.</p>

                            <p>Online Upgrade: No direct online upgrade. You need to cancel your current booking (if refundable) and book a new ticket in the desired class.</p>

                            <p>Tatkal Quota: No upgrades allowed for Tatkal tickets.</p>

                            <p>Important: Upgrades are subject to availability, and fare differences may apply, except for the complimentary upgrade scheme.</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateProps = createStructuredSelector({
    urlData: selectUrlData
})

export default connect(mapStateProps, null)(FaqDetailsTrainInfo);
